module.exports = __webpack_public_path__ + "6fbd802f701d391e33dcb027444762fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/eg_bg.png
// module id = 1103
// module chunks = 0